import {lazy, Suspense, useEffect, useRef, useState} from 'react';
import classNames from 'classnames';

const MuxPlayer = lazy(() => import('@mux/mux-player-react'));

/**
 * @typedef {Object} VideoModel
 * @property {string} playbackId
 * @property {string} overridePlaybackId
 */

/**
 * @param {HalfSizeTeaserModel | FocusTeaserModel | TopicCarouselTeaserModel} model
 * @param {number} [aspectRatio]
 * @param {ReactNode} [children]
 * @param {String} className
 * @returns {JSX.Element}
 */
export function Video({model, aspectRatio, children, className}) {
    const videoModel = model.video;
    if (!videoModel) return children;
    const videoEl = useRef(null);

    const [error, setError] = useState(false);

    useEffect(() => {
        videoEl.current &&
            videoEl.current.play().catch((error) => {
                console.error('Error attempting to play', error);
            });
    }, []);

    const usedPlaybackId =
        videoModel.overridePlaybackId && window.innerWidth >= 768
            ? videoModel.overridePlaybackId
            : videoModel.playbackId;

    return error ? (
        children
    ) : (
        <Suspense fallback={<div />}>
            <MuxPlayer
                className={classNames('content-platform__mux-video', className)}
                style={{aspectRatio: aspectRatio}}
                streamType="live"
                loop
                autoPlay
                muted
                disableCookies
                disableTracking
                ref={videoEl}
                onError={() => setError(true)}
                playbackId={usedPlaybackId}
            />
        </Suspense>
    );
}
